module.exports = __webpack_public_path__ + "img/round-person.c009c3ae.svg";